const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

delay.cancel = (ms: number, options: { task: () => void }) => {
  const timer = setTimeout(options.task, ms)

  return {
    done: (callback: () => void) => {
      clearTimeout(timer)
      callback()
    },
  }
}

delay.race = (ms: number, options: { waiter: () => Promise<Any> }) => {
  const start = Date.now()

  return options.waiter().then((data) => {
    const usedTime = Date.now() - start

    if (usedTime < ms) {
      return delay(ms - usedTime).then(() => data)
    }

    return data
  })
}

export default delay
